var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.localized)?_c(_vm.component,_vm._b({tag:"component"},'component',_vm.$props,false)):_c('div',{staticClass:"monthlyPayment-content"},[_vm._v(" "+_vm._s(_vm.$t("review-table.monthlyPaymentAmount", {formattedMonthlyPayment:_vm.formattedMonthlyPayment, creditTerm: _vm.creditTerm}))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }